import { render, staticRenderFns } from "./tpl.html?vue&type=template&id=a6d35d56&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./style/index.scss?vue&type=style&index=0&id=a6d35d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d35d56",
  null
  
)

export default component.exports